var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      staticClass: "basic-modal policy-modal hide-cancel-btn",
      attrs: {
        id: _vm.id,
        title: _vm.title,
        "ok-title": _vm.$t("common.close")
      },
      on: { shown: _vm.onOpen }
    },
    [
      _c(
        "div",
        { staticClass: "policy-container scroll-box" },
        [
          _vm.markdown
            ? _c("VueMarkdown", { attrs: { source: _vm.markdown } })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-070b65ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-070b65ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolicyModal.vue
// module id = 0xvn
// module chunks = 1